import type { SVGProps } from "react";
export default function ClockCheckSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={20}
      fill="none"
      viewBox="0 0 19 20"
      className="flex shrink-0 grow-0"
      {...props}
    >
      <g clipPath="url(#clip0_17244_1324)">
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.583}
          d="m11.48 15.226 1.582 1.583 3.563-3.562m.78-3.127q.012-.217.012-.436a7.917 7.917 0 1 0-8.124 7.914M9.5 4.934v4.75l2.96 1.48"
        />
      </g>
      <defs>
        <clipPath id="clip0_17244_1324">
          <rect
            width={19}
            height={19}
            fill="#fff"
            transform="translate(0 .184)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
